import { ProductShapeIds as P } from '../settings';
import { getLocalizedText as t } from '@vp-dst/localization-util';

export function getProductShortName(productShapeId: string): string {
  switch (productShapeId) {
    case P.NA_STANDARD_BUSINESS_CARD:
    case P.NA_VERTICAL_STANDARD_BUSINESS_CARD:
    case P.EU_STANDARD_BUSINESS_CARD:
    case P.EU_VERTICAL_STANDARD_BUSINESS_CARD:
      return t('standard');
    case P.NA_ROUNDED_CORNER_BUSINESS_CARD:
    case P.NA_VERTICAL_ROUNDED_CORNER_BUSINESS_CARD:
    case P.EU_ROUNDED_CORNER_BUSINESS_CARD:
    case P.EU_VERTICAL_ROUNDED_CORNER_BUSINESS_CARD:
      return t('rounded-corners');
    case P.NA_SQUARE_BUSINESS_CARD:
    case P.EU_SQUARE_BUSINESS_CARD:
      return t('square');
    case P.EU_SLIM_BUSINESS_CARD:
    case P.EU_VERTICAL_SLIM_BUSINESS_CARD:
      return t('slim');
    default:
      return '';
  }
}

export function getProductFullName(productShapeId: string): string {
  switch (productShapeId) {
    case P.NA_STANDARD_BUSINESS_CARD:
    case P.NA_VERTICAL_STANDARD_BUSINESS_CARD:
    case P.EU_STANDARD_BUSINESS_CARD:
    case P.EU_VERTICAL_STANDARD_BUSINESS_CARD:
      return t('standard') + ' business cards';
    case P.NA_ROUNDED_CORNER_BUSINESS_CARD:
    case P.NA_VERTICAL_ROUNDED_CORNER_BUSINESS_CARD:
    case P.EU_ROUNDED_CORNER_BUSINESS_CARD:
    case P.EU_VERTICAL_ROUNDED_CORNER_BUSINESS_CARD:
      return t('rounded-corners') + ' business cards';
    case P.NA_SQUARE_BUSINESS_CARD:
    case P.EU_SQUARE_BUSINESS_CARD:
      return t('square') + ' business cards';
    case P.EU_SLIM_BUSINESS_CARD:
    case P.EU_VERTICAL_SLIM_BUSINESS_CARD:
      return t('slim') + ' business cards';
    default:
      return '';
  }
}
